import React from 'react';
import { RowMd7, WhiteBlock } from 'app/blocks/blocks';
import { Button, PrimaryButton } from 'app/blocks/buttons/buttons';
import { withCodes, ID } from 'app/blocks/common/codes';
import withScrollToContent from 'app/blocks/common/withScrollToContent';
import { useOpenAccessOrderFlow } from 'app/pages/orders/oa/OpenAccessOrderContext';
import flow from 'app/pages/orders/orders.flow';
import OrdersSingleOA from 'app/pages/orders/single/oa';

function OrdersOAReview({ l }) {
    const {
        agreementRequiredAndNotProvided,
        initOrder,
        isCanceling,
        isReviewConfirming,
        isSavingForLater,
        onCancelOrder,
        onRequestEditOrder,
        onReviewConfirm,
        onSaveForLater,
        order,
        toggleAgreement,
        alipayAgreementRequiredAndNotProvided,
        toggleAgreementAlipay,
        cpsError,
        ignoredCpsErrors,
        specificCpsErrors,
    } = useOpenAccessOrderFlow();

    return (
        <RowMd7>
            <WhiteBlock>
                <OrdersSingleOA
                    cpsErrorText={l(
                        `LICENSE_SIGNING.PAYMENT.CPS_ERRORS.${
                            specificCpsErrors.includes(cpsError) ? cpsError : 'GENERIC'
                        }`,
                    )}
                    handleAgreeToPayChange={toggleAgreement}
                    handleAgreeToSocopayPolicy={toggleAgreementAlipay}
                    initOrder={initOrder}
                    isAgreeToPay={!agreementRequiredAndNotProvided}
                    isAgreeToSocopayPolicy={!alipayAgreementRequiredAndNotProvided}
                    onRequestEditOrder={onRequestEditOrder}
                    order={order}
                    shouldShowCpsError={cpsError && !ignoredCpsErrors.includes(cpsError)}
                />
            </WhiteBlock>

            <div className="row m-top_md">
                <div className="col-3">
                    <Button data-seleniumid="order-cancel-button" disabled={isCanceling} onClick={onCancelOrder}>
                        {isCanceling ? l('BUTTONS.CANCELING') : l('BUTTONS.CANCEL')}
                    </Button>
                </div>
                <div className="col-9 text-right">
                    {!(order && order.existing) && (
                        <Button
                            className="m-l_mini m-btm_mini"
                            data-seleniumid="order-saveForLater-button"
                            disabled={isReviewConfirming || isSavingForLater}
                            onClick={onSaveForLater}
                        >
                            {!isSavingForLater ? l('BUTTONS.SAVE_FOR_LATER') : l('BUTTONS.SAVING')}
                        </Button>
                    )}
                    {flow.isPaymentMethodAlipay(order) && (
                        <PrimaryButton
                            className="m-l_mini m-btm_mini id-oa-order-pay-button"
                            data-seleniumid="order-next-button"
                            disabled={
                                isReviewConfirming ||
                                isSavingForLater ||
                                agreementRequiredAndNotProvided ||
                                alipayAgreementRequiredAndNotProvided
                            }
                            onClick={onReviewConfirm}
                        >
                            {!isReviewConfirming ? l('BUTTONS.NEXT') : l('BUTTONS.SAVING')}
                        </PrimaryButton>
                    )}
                    {!flow.isPaymentMethodAlipay(order) && (
                        <PrimaryButton
                            className="m-l_mini m-btm_mini id-oa-order-pay-button"
                            data-seleniumid="order-next-button"
                            disabled={isReviewConfirming || isSavingForLater || agreementRequiredAndNotProvided}
                            onClick={onReviewConfirm}
                        >
                            {!isReviewConfirming ? l('BUTTONS.NEXT') : l('BUTTONS.SAVING')}
                        </PrimaryButton>
                    )}
                </div>
            </div>
        </RowMd7>
    );
}

export default withCodes(withScrollToContent(OrdersOAReview), ID.BUTTONS, ID.LICENSE_SIGNING);
